import { AlertCircle } from 'lucide-react';

/** A read that failed or is offline would look like an empty one, so the gap is named. */
export function ReadNotice({ read, subject }: { read: { status: string }; subject: string }) {
  if (read.status !== 'failed' && read.status !== 'offline') return null;
  return (
    <div role="alert" className="flex items-center gap-2 rounded-md border border-destructive/30 bg-destructive/5 px-3 py-2 text-sm text-destructive">
      <AlertCircle className="h-4 w-4 shrink-0" aria-hidden />
      {read.status === 'offline' ? `You're offline, so ${subject} can't load.` : `Couldn't load ${subject}. Refresh to try again.`}
    </div>
  );
}
